import { render } from "./TemplateSetting.vue?vue&type=template&id=4b29017b&scoped=true"
import script from "./TemplateSetting.vue?vue&type=script&lang=js"
export * from "./TemplateSetting.vue?vue&type=script&lang=js"

import "./TemplateSetting.vue?vue&type=style&index=0&id=4b29017b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b29017b"]])

export default __exports__